import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { ProductType } from 'src/types/product';
import { useNavigate } from 'react-router-dom';
import ExportTableAction from 'src/components/ExportTableAction';
import { ExportTypeType } from 'src/types/table';

export interface TopBlockPropsType {
    data: ProductType | null;
    idProduct: string | undefined;
    newProduct: boolean;
    disableEdit: boolean;
    permissionDelete: boolean;
    permissionBillOfMaterials: boolean;
    loading: boolean;
    handleSave: () => boolean;
    handleDeleteProduct: () => void;
    showProductStockTable: boolean;
    setShowProductStockTable: (value: boolean) => void;
    activeTab: string;
    onChangeTab: (value: string) => void;
    handleExportStockMovements: (type: ExportTypeType) => void;
    handleExportProductReceivings: (type: ExportTypeType) => void;
    handleExportProductOrders: (type: ExportTypeType) => void;
    handleExportProductReturns: (type: ExportTypeType) => void;
    permissionReceivingList: boolean;
    permissionReturnList: boolean;
    productType?: string;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const navigate = useNavigate();

    const handleBillsOfMaterials = () => {
        navigate(`bill_of_materials/`);
    };

    const isGridTab =
        props.activeTab === 'stockMovements' ||
        props.activeTab === 'productReceivings' ||
        props.activeTab === 'productOrders' ||
        props.activeTab === 'productReturns';

    const tabs = [
        { value: 'detail', label: translate('productDetail.detail') },
    ];

    if (!props.newProduct) {
        tabs.push({ value: 'eans', label: translate('productDetail.eansTab.title') });
    }

    if (props.productType === 'pack') {
        tabs.push({ value: 'productSet', label: translate('productDetail.productSetTab.title') });
    }

    if (!props.newProduct) {
        tabs.push({ value: 'productOrders', label: translate('productDetail.productOrders') });
        if (props.permissionReceivingList) {
            tabs.push({ value: 'productReceivings', label: translate('productDetail.productReceivings') });
        }
        if (props.permissionReturnList) {
            tabs.push({ value: 'productReturns', label: translate('productDetail.productReturns') });
        }
        tabs.push(
            { value: 'stockMovements', label: translate('productDetail.stockMovements') },
            { value: 'history', label: translate('productDetail.history') }
        );
    }

    return (
        <>
            <BodyTopBlock
                tabs={tabs}
                selectTab={props.activeTab}
                onChangeTab={props.onChangeTab}
                actions={[
                    {
                        node: (
                            <ExportTableAction
                                title={translate('productDetail.exportStockMovements')}
                                handleExport={props.handleExportStockMovements}
                            />
                        ),
                        hidden: props.newProduct || props.activeTab !== 'stockMovements',
                    },
                    {
                        node: (
                            <ExportTableAction
                                title={translate('productDetail.exportProductReceivings')}
                                handleExport={props.handleExportProductReceivings}
                            />
                        ),
                        hidden: props.newProduct || props.activeTab !== 'productReceivings',
                    },
                    {
                        node: (
                            <ExportTableAction
                                title={translate('productDetail.exportProductOrders')}
                                handleExport={props.handleExportProductOrders}
                            />
                        ),
                        hidden: props.newProduct || props.activeTab !== 'productOrders',
                    },
                    {
                        node: (
                            <ExportTableAction
                                title={translate('productDetail.exportProductReturns')}
                                handleExport={props.handleExportProductReturns}
                            />
                        ),
                        hidden: props.newProduct || props.activeTab !== 'productReturns',
                    },
                    {
                        icon: <ReceiptIcon />,
                        onClick: () => props.setShowProductStockTable(!props.showProductStockTable),
                        tooltip: translate('productDetail.productStock'),
                        active: props.showProductStockTable,
                        hidden: props.newProduct || isGridTab,
                        variant: 'outlined',
                    },
                    {
                        icon: <VerticalSplitIcon />,
                        onClick: handleBillsOfMaterials,
                        tooltip: translate('productDetail.billsOfMaterials'),
                        hidden: props.newProduct || !props.permissionBillOfMaterials || isGridTab,
                        variant: 'outlined',
                    },
                    {
                        label: translate(props.newProduct ? 'productDetail.create' : 'productDetail.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                        disabled: props.loading,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
